var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGender(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#00d681",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380 470 c0 -5 14 -10 32 -10 l32 0 -43 -44 -43 -44 -35 24 c-62 41 -133 28 -187 -36 -21 -26 -26 -42 -26 -85 0 -46 5 -60 30 -89 17 -19 47 -40 65 -46 31 -10 35 -16 35 -46 0 -31 -3 -34 -30 -34 -16 0 -30 -4 -30 -10 0 -5 14 -10 30 -10 23 0 30 -4 30 -20 0 -11 5 -20 10 -20 6 0 10 9 10 20 0 16 7 20 30 20 17 0 30 5 30 10 0 6 -13 10 -30 10 -27 0 -30 3 -30 34 0 30 4 36 35 46 18 6 48 27 65 46 25 29 30 43 30 85 0 28 -4 58 -10 68 -7 14 0 27 35 61 l45 44 0 -32 c0 -18 5 -32 10 -32 6 0 10 23 10 50 l0 50 -50 0 c-27 0 -50 -4 -50 -10z m-74 -86 c86 -41 86 -177 0 -218 -43 -20 -69 -20 -112 0 -85 41 -86 176 -2 217 42 21 71 21 114 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 300 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10 -40 0 -70 -4 -70 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 240 c0 -6 30 -10 70 -10 40 0 70 4 70 10 0 6 -30 10 -70 10 -40 0 -70 -4 -70 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/assets/gender.svg";
export { ForwardRef as ReactComponent };